import {
  isStructuredSession,
  LUBAV_SUPERSESSIONS,
  LubavSessionType,
} from '@backrs_ui/grow-ui/src/models/models';

export const determineActiveSession = (
  path: string,
  currentActiveSession: LubavSessionType | null = null,
): LubavSessionType | null => {
  // check if we're in a solution session
  if (path.startsWith('/solution-session/')) {
    const [pathname, queryString] = path.split('?');
    const sessionId = pathname.split('/')[2];
    const urlParams = new URLSearchParams(queryString || '');
    const subsession = urlParams.get('subsession');

    // add subsession if found
    if (subsession) {
      return `${sessionId}.${subsession}` as LubavSessionType;
    }

    return sessionId as LubavSessionType;
  }
  // check if we're in an office hours session
  else if (path.startsWith('/office-hours/')) {
    const sessionType = path.split('/')[2];

    return sessionType as LubavSessionType;
  }
  // check if we're in a supercoach session
  else if (path === '/supercoach') {
    return LUBAV_SUPERSESSIONS.SUPERCOACH;
  }

  // Structured sessions carry across pages that name none; supercoach ends with the page that
  // started it.
  if (isStructuredSession(currentActiveSession)) {
    return currentActiveSession;
  }

  return LUBAV_SUPERSESSIONS.OFFICE_HOURS;
};
